/* tslint:disable */
/* eslint-disable */
import { GlobalEnumsAceStudienabschluss as AceXFoundPortalCoreEntitiesGlobalEnumsAceStudienabschluss } from '../../../../../../ace/xFound/Portal/Core/Entities/global-enums-ace-studienabschluss';
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IStipendiumDisplayModel {
  angestrebterStudienabschluss?: AceXFoundPortalCoreEntitiesGlobalEnumsAceStudienabschluss;
  beantragteFoerdersumme?: null | number;
  bic?: null | string;
  iban?: null | string;
  immatrikulationsnummer?: null | string;
  kontoinhaber?: null | string;
  nameDesKreditInstituts?: null | string;
  studienbeginn?: null | string;
  studienende?: null | string;
  studienfach?: null | string;
  title?: null | string;
  universitaet?: null | string;
}
export class StipendiumDisplayModel extends BaseModel implements IStipendiumDisplayModel {
  angestrebterStudienabschluss?: AceXFoundPortalCoreEntitiesGlobalEnumsAceStudienabschluss;
  beantragteFoerdersumme?: null | number;
  bic?: null | string;
  iban?: null | string;
  immatrikulationsnummer?: null | string;
  kontoinhaber?: null | string;
  nameDesKreditInstituts?: null | string;
  studienbeginn?: null | string;
  studienende?: null | string;
  studienfach?: null | string;
  title?: null | string;
  universitaet?: null | string;
}
class BaseStipendiumDisplayModelFormGroup extends FormGroup {
  private static _instance: StipendiumDisplayModelFormGroup;
  
  public static get Instance(): StipendiumDisplayModelFormGroup {
    this._instance = new StipendiumDisplayModelFormGroup({
      angestrebterStudienabschluss: new FormControl(null),
      beantragteFoerdersumme: new FormControl(null),
      bic: new FormControl(null),
      iban: new FormControl(null),
      immatrikulationsnummer: new FormControl(null),
      kontoinhaber: new FormControl(null),
      nameDesKreditInstituts: new FormControl(null),
      studienbeginn: new FormControl(null),
      studienende: new FormControl(null),
      studienfach: new FormControl(null),
      title: new FormControl(null),
      universitaet: new FormControl(null),
    });

    return this._instance;
  }
}


export class StipendiumDisplayModelFormGroup extends BaseStipendiumDisplayModelFormGroup {
  public get AngestrebterStudienabschluss(): FormControl {
    return this.controls["angestrebterStudienabschluss"] as FormControl;
  }
  public get BeantragteFoerdersumme(): FormControl {
    return this.controls["beantragteFoerdersumme"] as FormControl;
  }
  public get Bic(): FormControl {
    return this.controls["bic"] as FormControl;
  }
  public get Iban(): FormControl {
    return this.controls["iban"] as FormControl;
  }
  public get Immatrikulationsnummer(): FormControl {
    return this.controls["immatrikulationsnummer"] as FormControl;
  }
  public get Kontoinhaber(): FormControl {
    return this.controls["kontoinhaber"] as FormControl;
  }
  public get NameDesKreditInstituts(): FormControl {
    return this.controls["nameDesKreditInstituts"] as FormControl;
  }
  public get Studienbeginn(): FormControl {
    return this.controls["studienbeginn"] as FormControl;
  }
  public get Studienende(): FormControl {
    return this.controls["studienende"] as FormControl;
  }
  public get Studienfach(): FormControl {
    return this.controls["studienfach"] as FormControl;
  }
  public get Title(): FormControl {
    return this.controls["title"] as FormControl;
  }
  public get Universitaet(): FormControl {
    return this.controls["universitaet"] as FormControl;
  }
  

}

export module StipendiumDisplayModelForm
  {
    export class FormFields
    {
      static _angestrebterStudienabschluss: string = "angestrebterStudienabschluss";
      static _beantragteFoerdersumme: string = "beantragteFoerdersumme";
      static _bic: string = "bic";
      static _iban: string = "iban";
      static _immatrikulationsnummer: string = "immatrikulationsnummer";
      static _kontoinhaber: string = "kontoinhaber";
      static _nameDesKreditInstituts: string = "nameDesKreditInstituts";
      static _studienbeginn: string = "studienbeginn";
      static _studienende: string = "studienende";
      static _studienfach: string = "studienfach";
      static _title: string = "title";
      static _universitaet: string = "universitaet";
    }
  }

